import Reveal from '@/components/base/Reveal';
import { downloadPackages } from '@/mocks/home';
import SectionHeading from './SectionHeading';

interface DownloadZoneProps {
  notify: (msg: string) => void;
}

export default function DownloadZone({ notify }: DownloadZoneProps) {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-8 md:py-16">
        <Reveal>
          <SectionHeading
            kicker="醒目下载区"
            icon="ri-download-cloud-2-line"
            title="爆瓜福利资源包下载专区"
            desc="按类型整理的高频资源包，标注体积与文件格式，下载入口放在最显眼的位置，点一下直接取用。"
            action={
              <span className="flex items-center gap-2 rounded-md border border-primary-200 bg-primary-50 px-4 py-2 text-sm text-primary-700">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-shield-check-line"></i>
                </span>
                链接每日巡检
              </span>
            }
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {downloadPackages.map((pack, index) => (
            <Reveal key={pack.id} delay={index * 70}>
              <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
                <div className="relative h-44 w-full overflow-hidden bg-background-200">
                  <img
                    src={pack.cover}
                    alt={`${pack.name} 资源包封面`}
                    title={`${pack.name} 下载 - 爆瓜福利资源包`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className={`absolute left-3 top-3 rounded-sm px-2 py-0.5 text-[11px] font-medium ${pack.badgeClass}`}>
                    {pack.badge}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h4 className="font-medium leading-snug text-foreground-950">{pack.name}</h4>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{pack.desc}</p>
                  <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                    <span className="rounded-sm bg-background-100 px-2 py-0.5">{pack.size}</span>
                    <span className="rounded-sm bg-secondary-100 px-2 py-0.5 text-secondary-800">{pack.format}</span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-download-2-line"></i>
                      </span>
                      {pack.downloads}
                    </span>
                  </div>
                  <div className="mt-auto pt-4">
                    <button
                      type="button"
                      onClick={() => notify(`已开始获取：${pack.name}`)}
                      className="flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                    >
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-download-2-line"></i>
                      </span>
                      立即下载资源包
                    </button>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}